import { PerDiemDestination } from "@finway-group/shared/lib/models"
import { generatePerDiemDestinationTree } from "Features/pages/expenses/expenseUtils"
import { useSelector } from "react-redux"
import { RootState } from "Shared/store/rootState.interface"

export const usePerDiemDestinations = (asTree = false) => {
    const destinations = useSelector(({ perDiemDestinations }: RootState) => perDiemDestinations.items)
    if (asTree) {
        return generatePerDiemDestinationTree(destinations)
    }
    return destinations
}

export const usePerDiemDestinationMap = () => {
    const destinations = useSelector(({ perDiemDestinations }: RootState) => perDiemDestinations.items)
    return new Map<string, PerDiemDestination>(destinations.map((d) => [d._id, d]))
}

export const usePerDiemDestinationById = (id: string) => {
    const destinations = useSelector(({ perDiemDestinations }: RootState) => perDiemDestinations.items)
    return destinations.find((d) => d._id === id)
}
